import { useNavigate } from 'react-router-dom';
import { Card, Button, Badge } from '@/components/ui';
import { Building2, BarChart3 } from 'lucide-react';

interface Restaurant {
  id: string;
  nom: string;
}

interface MultiRestaurantSectionProps {
  restaurants: Restaurant[];
}

export function MultiRestaurantSection({ restaurants }: MultiRestaurantSectionProps) {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
        <Building2 className="text-primary" size={20} />
        Mes Restaurants ({restaurants.length})
      </h2>
      <Card
        padding="md"
        className="bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/30 dark:to-purple-900/30 border-indigo-200 dark:border-indigo-700"
      >
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-start sm:items-center gap-3 sm:gap-4">
            <div className="p-2 sm:p-3 bg-indigo-500 rounded-lg flex-shrink-0">
              <BarChart3 className="text-white" size={24} />
            </div>
            <div className="min-w-0">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-1 text-sm sm:text-base">
                Vue Globale des Stocks
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                Visualisez les stocks de tous vos restaurants
              </p>
              <div className="flex flex-wrap items-center gap-1 sm:gap-2 mt-2">
                {restaurants.map((r) => (
                  <Badge key={r.id} variant="info" size="sm">
                    {r.nom}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
          <Button
            onClick={() => navigate('/global-stocks')}
            size="sm"
            className="w-full sm:w-auto flex-shrink-0"
          >
            <BarChart3 size={16} />
            <span className="ml-1">Stocks globaux</span>
          </Button>
        </div>
      </Card>
    </div>
  );
}
